import {jsx as _jsx, jsxs as _jsxs} from "react/jsx-runtime";import styled from '@emotion/styled'
import {useCallback, useEffect, useRef, useState} from 'react'
import relativeDate from '../../utils/date/relativeDate'
import getRefreshPeriod from '../../utils/getRefreshPeriod'
import Ellipsis from '../Ellipsis/Ellipsis'


const StyledWrapper = styled('span')({
  display: 'block',
  overflow: 'visible',
  overflowWrap: 'break-word'
})









const useTimeFrom = (timestamp) => {
  const makeTimeFrom = useCallback(
    () => relativeDate(timestamp, {smallDiff: 'just now'}),
    [timestamp]
  )
  const [timeFrom, setTimeFrom] = useState(makeTimeFrom)
  const timeoutRef = useRef()
  useEffect(() => {
    timeoutRef.current = window.setTimeout(() => {
      setTimeFrom(makeTimeFrom())
    }, getRefreshPeriod(timestamp))
    return () => {
      window.clearTimeout(timeoutRef.current)
    }
  }, [makeTimeFrom, timeFrom, timestamp])
  // to update on toggle
  useEffect(() => {
    setTimeFrom(makeTimeFrom())
  }, [timestamp, makeTimeFrom])

  return timeFrom
}

const EditingStatusText = (props) => {
  const {editors, isEditing, timestamp, timestampType, isArchived} = props
  const timestampLabel = timestampType === 'createdAt' ? 'Created ' : 'Updated '
  const timeFrom = useTimeFrom(timestamp)
  if (isArchived) {
    return _jsx('span', { children: `${timestampLabel}${timeFrom}`})
  }
  if (editors.length === 0) {
    if (isEditing) {
      return (
        _jsxs('span', { children: [
          'Editing'
          , _jsx(Ellipsis, {} )
        ]})
      )
    }
    return _jsx('span', { children: `${timestampLabel}${timeFrom}`})
  }
  const editorNames = editors.map((editor) => editor.preferredName)
  // one other is editing
  if (editors.length === 1) {
    const editor = editorNames[0]
    return (
      _jsxs(StyledWrapper, { children: [
        editor
        , ' is editing'
        , isEditing ? ' too' : ''
        , _jsx(Ellipsis, {} )
      ]})
    )
  }
  if (editors.length === 2) {
    if (isEditing) {
      return (
        _jsxs('span', { children: ["several people are editing"

          , _jsx(Ellipsis, {} )
        ]})
      )
    }
    return (
      _jsxs('span', { children: [
        `${editorNames[0]} and ${editorNames[1]} are editing`
        , _jsx(Ellipsis, {} )
      ]})
    )
  }
  return (
    _jsxs('span', { children: [
      'Several people are editing'
      , _jsx(Ellipsis, {} )
    ]})
  )
}

export default EditingStatusText
